import DeleteOutlineRoundedIcon from "@mui/icons-material/DeleteOutlineRounded";
import {Box, Checkbox, Colors, Text} from "@bounce/shared/ui";
import {Button} from "../../ui/components";

type CheckboxState = "checked" | "indeterminate" | "unchecked";

type Props = {
  selectedCount: number;
  checkboxState: CheckboxState;
  onToggleAll: () => void;
  onDelete: () => void;
};

const HEADER_HEIGHT = 44;
const CHECKBOX_COL_WIDTH = 50;

const barSx = {
  position: "absolute",
  top: 0,
  left: 0,
  right: 0,
  height: HEADER_HEIGHT,
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  backgroundColor: Colors.blue._100,
  borderBottom: `1px solid ${Colors.tertiary._300}`,
  zIndex: 3,
} as const;

const deleteButtonSx = {
  height: 28,
  fontSize: 13,
  fontWeight: 500,
  borderRadius: "6px",
  textTransform: "none",
  gap: 0.5,
  px: 1.5,
  border: `1px solid ${Colors.tertiary._300}`,
  backgroundColor: Colors.bw.white,
  color: Colors.grey._800,
  "&:hover": {
    backgroundColor: Colors.red._100,
    borderColor: Colors.red._400,
    color: Colors.red._800,
  },
} as const;

export const AssetsBatchActions = ({selectedCount, checkboxState, onToggleAll, onDelete}: Props) => (
  <Box sx={barSx} role="toolbar" aria-live="polite">
    <Box sx={{display: "flex", alignItems: "center"}}>
      <Box
        sx={{
          width: CHECKBOX_COL_WIDTH,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0,
        }}
      >
        <Checkbox
          size="small"
          checked={checkboxState === "checked"}
          indeterminate={checkboxState === "indeterminate"}
          onChange={onToggleAll}
        />
      </Box>
      <Text size={13} variant="inter600" sx={{color: Colors.grey._800, pl: 1.5}}>
        {`${selectedCount} selected`}
      </Text>
    </Box>
    <Box sx={{display: "flex", alignItems: "center", gap: 0.75, pr: 2.5}}>
      <Button buttonType="outlined-primary" size="small" onClick={onDelete} sx={deleteButtonSx}>
        <DeleteOutlineRoundedIcon sx={{fontSize: 16}} />
        Delete
      </Button>
    </Box>
  </Box>
);
